export * from './feld-kategories-filter.component';
export * from './feld-kategories-filter.component.module';